import { render, staticRenderFns } from "./DialogDetails.vue?vue&type=template&id=099989e0&scoped=true"
import script from "./DialogDetails.vue?vue&type=script&lang=js"
export * from "./DialogDetails.vue?vue&type=script&lang=js"
import style0 from "./css/common.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DialogDetails.vue?vue&type=style&index=1&id=099989e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099989e0",
  null
  
)

export default component.exports